import { useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "buzas-cookie-consent";

export const CookieConsent = () => {
    const [visible, setVisible] = useState(
        () => !window.localStorage.getItem(STORAGE_KEY),
    );

    const choose = (accepted) => {
        window.localStorage.setItem(
            STORAGE_KEY,
            accepted ? "accepted" : "declined",
        );
        if (window.posthog) {
            if (accepted) {
                window.posthog.opt_in_capturing();
            } else {
                window.posthog.opt_out_capturing();
            }
        }
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div
            role="region"
            aria-label="Aviso de cookies"
            data-testid="cookie-consent"
            className="fixed bottom-0 left-0 right-0 z-50 bg-buzas-navy text-white border-t border-white/10 shadow-[0_-8px_24px_rgba(10,37,64,0.25)]"
        >
            <div className="container-buzas py-4 flex flex-col md:flex-row md:items-center gap-4 md:gap-8">
                <p className="text-sm text-white/85 leading-relaxed md:flex-1">
                    Utilizamos cookies e tecnologias semelhantes para analisar
                    a navegação e melhorar sua experiência neste site. Saiba
                    mais em nossa{" "}
                    <Link
                        to="/politica-de-privacidade"
                        data-testid="cookie-consent-policy-link"
                        className="font-bold underline underline-offset-2 hover:text-white"
                    >
                        Política de Privacidade
                    </Link>
                    .
                </p>
                <div className="flex items-center gap-3 shrink-0">
                    <button
                        type="button"
                        onClick={() => choose(false)}
                        data-testid="cookie-consent-decline"
                        className="rounded-sm border border-white/25 px-5 py-2.5 text-sm font-bold text-white hover:bg-white hover:text-buzas-navy transition-colors"
                    >
                        Recusar
                    </button>
                    <button
                        type="button"
                        onClick={() => choose(true)}
                        data-testid="cookie-consent-accept"
                        className="rounded-sm bg-buzas-red px-5 py-2.5 text-sm font-bold text-white hover:bg-buzas-red-600 transition-colors"
                    >
                        Aceitar
                    </button>
                </div>
            </div>
        </div>
    );
};
